module.exports = "/_next/static/images/Hero-md@2x-2d8ca8b4b0bb75c9e991f2aa68c11f85.webp";